(() => {
  const canvas = document.querySelector('[data-orbit-mist]');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const header = canvas.closest('.om-header');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let width=1, height=1, raf=0, active=true, last=0, time=0, aim=0, lean=0;
  const place = () => {
    const h=header.getBoundingClientRect();
    width=Math.max(1,h.width); height=Math.max(1,h.height);
    canvas.style.left='0px';canvas.style.top='0px';
    canvas.style.width=`${width}px`;canvas.style.height=`${height}px`;
    const dpr=Math.min(devicePixelRatio||1,3);
    canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    draw(reduced.matches?12:time);
  };
  const smooth = n => { const v=Math.max(0,Math.min(1,n));return v*v*(3-2*v); };
  const hash = n => { const x=Math.sin(n*127.1+311.7)*43758.5453;return x-Math.floor(x); };
  function draw(t) {
    ctx.clearRect(0,0,width,height);
    if(width<40)return;
    const reveal=reduced.matches?1:smooth(t/1.5);
    ctx.globalAlpha=reveal;
    const count=width<700?1500:3200;
    const columns=Math.ceil(Math.sqrt(count*width/height));
    const rows=Math.ceil(count/columns);
    const dx=(width-12)/(columns-1),dy=(height-12)/(rows-1);
    ctx.strokeStyle='rgba(38,38,38,.10)';ctx.lineWidth=.45;ctx.beginPath();
    for(let col=0;col<columns;col++){const x=6+col*dx;ctx.moveTo(x,6);ctx.lineTo(x,height-6);}
    for(let row=0;row<rows;row++){const y=6+row*dy;ctx.moveTo(6,y);ctx.lineTo(width-6,y);}
    ctx.stroke();
    const cycle=Math.floor(t/72),phase=t%72-60;
    const blockColumns=Math.ceil(columns/2);
    for(let i=0;i<columns*rows;i++){
      const col=i%columns,row=Math.floor(i/columns);
      const blockCol=Math.floor(col/2),blockRow=Math.floor(row/2);
      const seed=blockRow*blockColumns+blockCol+cycle*7919;
      const eligible=hash(seed)<.18&&blockCol*2+1<columns&&blockRow*2+1<rows;
      const delay=hash(seed+43)*8, duration=1.2+hash(seed+97)*1.8;
      const travel=eligible&&!reduced.matches?smooth((phase-delay)/duration):0;
      const localX=col%2,localY=row%2;
      const clockwise=hash(seed+131)>.5;
      const targetX=clockwise?1-localY:localY;
      const targetY=clockwise?localX:1-localX;
      const x=6+(col+(targetX-localX)*travel)*dx;
      const y=6+(row+(targetY-localY)*travel)*dy;
      const moving=travel>0&&travel<1;
      const emphasis=moving?Math.sin(Math.PI*travel):0;
      ctx.fillStyle=`rgba(32,32,32,${.2+emphasis*.35})`;
      ctx.beginPath();ctx.arc(x,y,.58,0,Math.PI*2);ctx.fill();
    }
    ctx.globalAlpha=1;
  }
  let lastDrawCycle=-1;
  const frame = now => {
    raf=0;if(!active||document.hidden||reduced.matches)return;
    if(last)time+=Math.min((now-last)/1000,.05);last=now;
    lean+=(aim-lean)*.025;
    if(time<2||time%72>59.9||lastDrawCycle!==Math.floor(time/72)){draw(time);lastDrawCycle=Math.floor(time/72);}
    raf=requestAnimationFrame(frame);
  };
  const resume=()=>{if(!raf&&active&&!document.hidden&&!reduced.matches){last=0;raf=requestAnimationFrame(frame);}else if(reduced.matches)draw(12);};
  const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;if(!active){cancelAnimationFrame(raf);raf=0;}else resume();});
  observer.observe(header);
  const resize=new ResizeObserver(place);resize.observe(header);
  header.addEventListener('pointermove',e=>{const b=header.getBoundingClientRect();aim=(e.clientY-b.top)/b.height-.5;},{passive:true});
  header.addEventListener('pointerleave',()=>aim=0);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;}else resume();});
  reduced.addEventListener('change',()=>{cancelAnimationFrame(raf);raf=0;resume();});
  window.addEventListener('pagehide',()=>{cancelAnimationFrame(raf);raf=0;});
  window.addEventListener('pageshow',resume);
  document.fonts.ready.then(()=>{place();resume();});
})();

(() => {
  const header=document.querySelector('.om-home .om-header');
  const logo=header?.querySelector('.om-logo');
  if(!header||!logo)return;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const random=()=>crypto.getRandomValues(new Uint32Array(1))[0]/4294967296;
  const canvas=document.createElement('canvas');
  canvas.setAttribute('aria-hidden','true');
  canvas.dataset.orbitGridReturn='';
  canvas.style.cssText='position:absolute;inset:0;pointer-events:none;z-index:2';
  const ctx=canvas.getContext('2d');
  if(!ctx)return;
  header.append(canvas);
  let width=0,height=0,dx=1,dy=1,columns=0,rows=0,origins=[],destinations=[];
  let timer=0,raf=0,visible=false,ready=false,paused=false,flights=[];
  const recentStarts=[],recentEnds=[];
  const remember=(list,value,limit)=>{list.push(value);if(list.length>limit)list.shift();};
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const snapX=x=>6+clamp(Math.round((x-6)/dx),0,columns-1)*dx;
  const snapY=y=>6+clamp(Math.round((y-6)/dy),0,rows-1)*dy;
  const canRun=()=>ready&&visible&&!paused&&!document.hidden&&!reduced.matches&&!header.hasAttribute('data-orbit-egg-active');
  const stop=()=>{clearTimeout(timer);timer=0;cancelAnimationFrame(raf);raf=0;flights=[];ctx.clearRect(0,0,width,height);};
  const schedule=()=>{
    if(!canRun()||timer)return;
    timer=setTimeout(launch,3500+random()*4000);
  };
  const route=points=>{
    const clean=points.filter((p,i)=>!i||Math.hypot(p.x-points[i-1].x,p.y-points[i-1].y)>.01);
    const path=[clean[0]];
    for(let i=1;i<clean.length-1;i++){
      const a=clean[i-1],b=clean[i],c=clean[i+1];
      const incoming=Math.hypot(b.x-a.x,b.y-a.y),outgoing=Math.hypot(c.x-b.x,c.y-b.y);
      const radius=Math.min(2.5,incoming*.35,outgoing*.35);
      const entry={x:b.x+(a.x-b.x)*radius/incoming,y:b.y+(a.y-b.y)*radius/incoming};
      const exit={x:b.x+(c.x-b.x)*radius/outgoing,y:b.y+(c.y-b.y)*radius/outgoing};
      path.push(entry);
      for(let j=1;j<=8;j++){const t=j/8,u=1-t;path.push({x:u*u*entry.x+2*u*t*b.x+t*t*exit.x,y:u*u*entry.y+2*u*t*b.y+t*t*exit.y});}
    }
    path.push(clean[clean.length-1]);
    const segments=path.slice(1).map((b,i)=>({a:path[i],b,length:Math.hypot(b.x-path[i].x,b.y-path[i].y)}));
    return {segments,length:segments.reduce((sum,s)=>sum+s.length,0)};
  };
  function launch(){
    timer=0;
    if(!canRun())return;
    if(document.documentElement.classList.contains('om-reveal-pending')||!origins.length||!destinations.length){schedule();return;}
    const count=random()<.5?1:2,now=performance.now();
    for(let i=0;i<count;i++){
      const edge=['top','bottom','left','right'][Math.floor(random()*4)];
      const trip=Math.floor(random()*3);
      const edgeOrigins=origins.filter(p=>p.edge===edge);
      const candidates=edgeOrigins.length?edgeOrigins:origins;
      const availableOrigins=candidates.filter(p=>!recentStarts.some(q=>Math.hypot(p.x-q.x,p.y-q.y)<9));
      const pool=availableOrigins.length?availableOrigins:candidates;
      const start=pool[Math.floor(random()*pool.length)];
      const endPool=destinations.filter(p=>!recentEnds.includes(p.id));
      if(!endPool.length)break;
      const distance=p=>Math.hypot(p.x-start.x,p.y-start.y);
      const nearby=endPool.slice().sort((a,b)=>distance(a)-distance(b)).slice(0,60);
      const medium=endPool.filter(p=>distance(p)>=width*.15&&distance(p)<=width*.5);
      const choices=trip===0?nearby:trip===1&&medium.length?medium:endPool;
      const end=choices[Math.floor(random()*choices.length)];
      remember(recentStarts,start,12);remember(recentEnds,end.id,40);
      const exit={x:start.edge==='left'?snapX(start.x-dx):start.edge==='right'?snapX(start.x+dx):snapX(start.x),y:start.edge==='top'?snapY(start.y-dy):start.edge==='bottom'?snapY(start.y+dy):snapY(start.y)};
      const bend={x:snapX(exit.x+(end.x-exit.x)*(.15+random()*.7)),y:snapY(6+random()*(height-12))};
      const entry=[start,start.edge==='left'||start.edge==='right'?{x:exit.x,y:start.y}:{x:start.x,y:exit.y},exit];
      let points;
      if(trip===0){
        points=random()<.5?[...entry,{x:end.x,y:exit.y},end]:[...entry,{x:exit.x,y:end.y},end];
      }else if(trip===2){
        const farX=snapX(width*(.72+random()*.22));
        const nearX=snapX(width*(.28+random()*.24));
        const upper=snapY(height*(.08+random()*.2));
        const lower=snapY(height*(.7+random()*.2));
        const firstY=random()<.5?upper:lower,secondY=firstY===upper?lower:upper;
        points=[...entry,{x:exit.x,y:firstY},{x:farX,y:firstY},{x:farX,y:secondY},{x:nearX,y:secondY},{x:nearX,y:end.y},end];
      }else points=random()<.5
        ?[...entry,{x:bend.x,y:exit.y},{x:bend.x,y:end.y},end]
        :[...entry,{x:exit.x,y:bend.y},{x:end.x,y:bend.y},end];
      const journey=route(points);
      flights.push({...journey,end,startAt:now+i*(180+random()*420),duration:Math.min(4800,(trip===0?900:1500)+journey.length/650*1000+random()*400)});
    }
    if(flights.length&&!raf)raf=requestAnimationFrame(draw);
    schedule();
  }
  function draw(now){
    raf=0;if(!canRun()){stop();return;}
    ctx.clearRect(0,0,width,height);
    flights=flights.filter(p=>now<p.startAt+p.duration+220);
    for(const p of flights){
      const raw=(now-p.startAt)/p.duration;if(raw<0)continue;
      const t=clamp(raw,0,1),ease=t*t*(3-2*t);
      let remaining=ease*p.length,x=p.end.x,y=p.end.y;
      for(const s of p.segments){if(remaining<=s.length&&s.length>0){const f=remaining/s.length;x=s.a.x+(s.b.x-s.a.x)*f;y=s.a.y+(s.b.y-s.a.y)*f;break;}remaining-=s.length;}
      const alpha=raw>1?Math.max(0,1-(now-p.startAt-p.duration)/220):Math.min(1,t*12);
      ctx.fillStyle=`rgba(25,25,25,${alpha*.72})`;ctx.fillRect(x-.8,y-.8,1.6,1.6);
    }
    if(flights.length)raf=requestAnimationFrame(draw);else schedule();
  }
  function measure(){
    stop();ready=false;
    const box=header.getBoundingClientRect(),rect=logo.getBoundingClientRect();
    width=box.width;height=box.height;
    if(width<40||height<40)return;
    const dpr=Math.min(devicePixelRatio||1,3);
    canvas.width=Math.ceil(width*dpr);canvas.height=Math.ceil(height*dpr);
    canvas.style.width=`${width}px`;canvas.style.height=`${height}px`;ctx.setTransform(dpr,0,0,dpr,0,0);
    const count=width<700?1500:3200;
    columns=Math.ceil(Math.sqrt(count*width/height));rows=Math.ceil(count/columns);
    dx=(width-12)/(columns-1);dy=(height-12)/(rows-1);
    const mask=document.createElement('canvas');mask.width=Math.ceil(width);mask.height=Math.ceil(height);
    const ink=mask.getContext('2d',{willReadFrequently:true});if(!ink)return;
    const style=getComputedStyle(logo);
    ink.font=`${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;ink.letterSpacing=style.letterSpacing;ink.textBaseline='alphabetic';
    const marker=document.createElement('i');marker.setAttribute('aria-hidden','true');
    marker.style.cssText='display:inline-block;width:0;height:0;padding:0;margin:0;border:0;vertical-align:baseline';
    logo.append(marker);const baseline=marker.getBoundingClientRect().top-box.top;marker.remove();
    ink.fillText(logo.textContent,rect.left-box.left,baseline);
    const pixels=ink.getImageData(0,0,mask.width,mask.height).data;
    const alpha=(x,y)=>pixels[(y*mask.width+x)*4+3]||0;
    origins=[];destinations=[];recentStarts.length=0;recentEnds.length=0;
    for(let y=2;y<mask.height-2;y+=2)for(let x=2;x<mask.width-2;x+=2){
      if(alpha(x,y)>160){
        if(alpha(x-2,y)<30)origins.push({x,y,edge:'left'});
        if(alpha(x+2,y)<30)origins.push({x,y,edge:'right'});
      }
    }
    for(let x=2;x<mask.width-2;x+=2){
      let top=-1,bottom=-1;
      for(let y=2;y<mask.height-2;y++){if(alpha(x,y)>160){if(top<0)top=y;bottom=y;}}
      if(top>=0){origins.push({x,y:top,edge:'top'},{x,y:bottom,edge:'bottom'});}
    }
    const exclusions=[...header.querySelectorAll('.om-brand,.om-search')].map(el=>{const r=el.getBoundingClientRect();return {left:r.left-box.left-8,right:r.right-box.left+8,top:r.top-box.top-8,bottom:r.bottom-box.top+8};});
    for(let row=1;row<rows-1;row++)for(let col=1;col<columns-1;col++){
      const x=6+col*dx,y=6+row*dy;
      if(!exclusions.some(r=>x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom))destinations.push({x,y,id:row*columns+col});
    }
    ready=true;schedule();
  }
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)schedule();else stop();});observer.observe(header);
  const resize=new ResizeObserver(()=>{if(ready)measure();});resize.observe(header);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();else schedule();});
  reduced.addEventListener('change',()=>{stop();schedule();});
  window.addEventListener('pagehide',()=>{paused=true;stop();});
  window.addEventListener('pageshow',()=>{paused=false;schedule();});
  header.addEventListener('orbit-egg-start',stop);
  header.addEventListener('orbit-egg-reset',measure);
  document.fonts.ready.then(measure);
})();
